/*'use strict';

$(function () {
    drift.on('ready',function(api, payload) {
    // interact with the api here
    if(window.innerWidth < 1024){
        api.widget.hide();
    }
    });
});*/